/* tslint no-explicit-any:off */

export interface ILogger {
    log: (args: any) => void;
    debug: (args: any) => void;
    info: (args: any) => void;
    notice: (args: any) => void;
    warn: (args: any) => void;
    error: (args: any) => void;
    fatal: (args: any) => void;
}

const NAME = 'MOJI';

const consoleExists =
    typeof console !== 'undefined' && !!console && typeof console.info === 'function';

let log = getLog(6);

function getLog(logLevel: number): ILogger {
    if (typeof logLevel !== 'number') {
        logLevel = 5;
    }
    return {
        log: !consoleExists || logLevel > 0 ? () => {} : getLogFunction('info'),
        debug: !consoleExists || logLevel > -1 ? () => {} : getLogFunction('debug'),
        info: !consoleExists || logLevel > 0 ? () => {} : getLogFunction('info'),
        notice: !consoleExists || logLevel > 1 ? () => {} : getLogFunction('notice', 'info'),
        warn: !consoleExists || logLevel > 2 ? () => {} : getLogFunction('warn', 'notice', 'info'),
        error: !consoleExists || logLevel > 3 ? () => {} : getLogFunction('error'),
        fatal: !consoleExists || logLevel > 4 ? () => {} : getLogFunction('fatal', 'error'),
    };
}

// @ts-ignore
function getLogFunction(target, ...alternatives) {
    // @ts-ignore
    if (typeof console[target] === 'function') {
        // @ts-ignore
        return console[target].bind(console);
    }
    if (!alternatives || !alternatives.length) {
        return console.log.bind(console);
    }
    // @ts-ignore
    return getLogFunction(...alternatives);
}

export function setLogLevel(logLevel: number) {
    log = getLog(logLevel);
}

// @ts-ignore
export function getLogger(name) {
    return Object.keys(log).reduce(
        (m, severity) => ({
            ...m,
            [severity]: getLogHandler(severity, name),
        }),
        {} as ILogger
    );
}

// @ts-ignore
function getLogHandler(severity, name) {
    // @ts-ignore
    if (typeof log[severity] !== 'function') {
        throw new Error(
            `There is no log method with name "${severity}" for generating logger "${name}"`
        );
    }
    // @ts-ignore
    return (...args) => {
        try {
            // @ts-ignore
            log[severity](`[${NAME}][${severity}]${name}`, ...args);
        } catch (error) {
            // [RS] Executing a log never generates an error
        }
    };
}

export default getLogger;
